import { cn } from "@/lib/utils";

interface FormHintProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "warning" | "info";
}

export function FormHint({ children, className, variant = "default" }: FormHintProps) {
  return (
    <p
      className={cn(
        "text-xs leading-relaxed",
        variant === "default" && "text-muted-foreground",
        variant === "warning" && "text-amber-800",
        variant === "info" && "text-navy-blueprint/80",
        className,
      )}
    >
      {children}
    </p>
  );
}
